"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_native_1 = require("react-native");
var hooks_1 = require("./hooks");
var Button_1 = __importDefault(require("./Button"));
var Col = function (props) {
    var btn = props.btn, onPress = props.onPress, onHoverStyle = props.onHoverStyle, onResponsiveStyle = props.onResponsiveStyle, useNestedHover = props.useNestedHover;
    var style = hooks_1.usePropsStyle(props);
    var compRef = react_1.useRef(null);
    var onRef = function (ref) {
        compRef.current = ref;
        if (props.onRef)
            props.onRef(ref);
    };
    var useNativeStyleProps = props.useNativeStyleProps === false ? false : true;
    var _a = hooks_1.useHoverStyle(onHoverStyle, useNestedHover ? false : useNativeStyleProps, style, compRef), hoverProps = _a[0], combinedStyle = _a[1], isHovered = _a[2];
    var responsiveStyle = hooks_1.useResponsiveStyle(onResponsiveStyle);
    var renderWithWrapper = function (children) {
        if (useNestedHover) {
            return (react_1.default.createElement(hooks_1.HoverContext.Provider, { value: { isHovered: isHovered, useHoverContext: useNestedHover } }, children));
        }
        return children;
    };
    var mainContent = Boolean(typeof onPress === 'function' || btn) ? (react_1.default.createElement(Button_1.default, __assign({ onRef: onRef, onPress: onPress, activeOpacity: 0.9 }, hoverProps, props, { style: [combinedStyle, responsiveStyle] }))) : (react_1.default.createElement(react_native_1.View, __assign({ ref: onRef }, hoverProps, props, { style: [combinedStyle, responsiveStyle] })));
    return renderWithWrapper(mainContent);
};
exports.default = Col;
//# sourceMappingURL=Col.js.map